import { UserExchangeField } from '@work4all/components/lib/components/entity-preview/user-preview/components/UserExchangeField';

import { useTenant } from '@work4all/data/lib/hooks/routing/TenantProvider';

import { FullUser } from '@work4all/models/lib/Classes/FullUser.entity';
import { UserSyncOptions } from '@work4all/models/lib/Classes/UserSyncOptions.entity';

import { useFormContextPlus } from '../../../../../form-plus/use-form-context-plus';
import { Panel } from '../../../../components';
import { UserFormValue } from '../../types';

export const ExchangeTabPanel = () => {
  const { watch, setValue } = useFormContextPlus<UserFormValue>();
  const { activeTenant } = useTenant();

  const user = watch();

  return (
    <Panel style={{ height: '100%' }}>
      <UserExchangeField
        value={user}
        onUserChange={(change) => {
          Object.entries(change).forEach(
            ([prop, value]: [keyof FullUser, FullUser[keyof FullUser]]) => {
              setValue(prop, value, {
                shouldDirty: true,
              });
            }
          );
        }}
        onChange={(opt: UserSyncOptions) => {
          setValue('syncOptionsEdit', opt, {
            shouldDirty: true,
          });

          // Update UI
          const prev = user.syncOptions || [];
          const found = prev.find((item) => item.tenantCode === activeTenant);

          let result: UserSyncOptions[] = null;
          if (found) {
            // Update existing
            result = prev.map((item) =>
              item.tenantCode === activeTenant ? { ...item, ...opt } : item
            );
          } else {
            // Add new
            result = [...prev, { ...opt, tenantCode: activeTenant }];
          }

          setValue('syncOptions', result, {
            shouldDirty: true,
          });
        }}
      />
    </Panel>
  );
};
